"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('abdominal', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M7.89975 5C10.7376 8.01931 12.1565 11.9408 12.1565 16.7645C12.1565 24 5.99999 29.5382 4.96949 33.5C4.28249 36.1412 3.95932 39.3078 3.99999 43",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M39.2567 5C36.4189 8.01931 35 11.9408 35 16.7645C35 24 41.1565 29.5382 42.187 33.5C42.874 36.1412 43.1972 39.3078 43.1565 43",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M6.2446 30.8369C12.7697 34.9668 18.6954 37.0317 24.0215 37.0317C29.3477 37.0317 34.9804 34.9668 40.9197 30.8369",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M24 31C25.3807 31 26.5 29.8807 26.5 28.5C26.5 27.1193 25.3807 26 24 26C22.6193 26 21.5 27.1193 21.5 28.5C21.5 29.8807 22.6193 31 24 31Z",
    fill: props.outStrokeColor
  }));
});

exports.default = _default;